import { FC } from 'react';

import { Settings, Sparkles } from 'lucide-react';

import { Badge } from '../../../components/ui/Badge';
import { Button } from '../../../components/ui/Button';
import { Card, CardContent } from '../../../components/ui/Card';
import { PremiumSummary } from '../../../types';

interface Props {
    premiumSummary: PremiumSummary;
    onManage: () => void;
}

export const PremiumServicesShortcut: FC<Props> = ({
    premiumSummary,
    onManage,
}) => (
    <Card
        className="mb-6 border-primary/10 bg-primary/5"
        data-testid="premium-shortcut"
    >
        <CardContent className="flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between">
            <div>
                <div className="flex items-center gap-2 text-base font-semibold">
                    <Sparkles className="h-4 w-4 text-primary" />
                    Premium пропозиції
                </div>
                <p className="mt-1 text-sm text-muted-foreground">
                    Зробіть свої пропозиції помітнішими та привертайте більше
                    уваги покупців. Купуйте premium-активації й просувайте
                    найкращі оголошення.
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                    <Badge variant="success">
                        Доступно: {premiumSummary.availableSlotsCount}
                    </Badge>
                    <Badge variant="info">
                        Активно: {premiumSummary.activeSlotsCount}
                    </Badge>
                    <Badge variant="outline">
                        Використано: {premiumSummary.usedSlotsCount}
                    </Badge>
                </div>
            </div>

            <Button type="button" className="shrink-0" onClick={onManage}>
                Керувати
                <Settings className="ml-2 h-4 w-4" />
            </Button>
        </CardContent>
    </Card>
);
